
import PropTypes from "prop-types";
import { useState } from "react";
import { Box, Typography, TextField } from "@mui/material";

import dayjs from "dayjs";


function DateOfBirth({
  label,
  formState,
  setFormState,
  setFormError,
}) {

  const [ day, setDay ] = useState("");
  const [ month, setMonth ] = useState("");
  const [ year, setYear ] = useState("");

  const handleDayChange = (e) => {
    const inputValue = e.target.value;
    if (
      /^(0?[1-9]|1[0-9]|2[0-9]|3[0-1])$/.test(inputValue) ||
      inputValue === "0" ||
      !inputValue
    ) {
      setDay(inputValue);
    };
  };

  const handleDayBlur = (e) => {
    if (day === "0" || day === "" || day === null) {
      setDay("");
      setFormState({
        ...formState,
        dateOfBirth: "",
      });
    } else if (month && year) {
      const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2,"0")}`;
      setFormState({
        ...formState,
        dateOfBirth: formattedDate,
      });
      setFormError(null);
    }
  };

  const handleMonthChange = (e) => {
    const inputValue = e.target.value;
    if (
      /^(0?[1-9]|1[0-2])$/.test(inputValue) ||
      inputValue === "0" ||
      !inputValue
    ) {
      setMonth(inputValue);
    };
  };

  const handleMonthBlur = (e) => {
    if (month === "0" || month === "" || month === null) {
      setMonth("");
      setFormState({
        ...formState,
        dateOfBirth: "",
      });
    } else if (day && year) {
      const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2,"0")}`;
      setFormState({
        ...formState,
        dateOfBirth: formattedDate,
      });
      setFormError(null);
    }
  };

  const handleYearChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d{0,4}$/.test(inputValue)) {
      setYear(inputValue);
    };
  };

  const handleYearBlur = (e) => {
    if (year === "" || year === null) {
      setYear("");
      setFormState({
        ...formState,
        dateOfBirth: "",
      });
      return;
    } else if (day && month) {
      const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2,"0")}`;
      setFormState({
        ...formState,
        dateOfBirth: formattedDate,
      });
      setFormError(null);
    }
  };

  return (
    <>
      <Typography
        id='dateOfBirthLabel'
        component='label'
        htmlFor='dateOfBirthInput'
        sx={{
          fontWeight: "bold"
        }}
      >
        {label}
      </Typography>
      <Box
        display='flex'
        alignItems='center'
        gap={1}
        sx={{ display: "block", my: 1, width: "100%" }}
      >
        <TextField
          margin='dense'
          value={day}
          onChange={handleDayChange}
          onBlur={handleDayBlur}
          placeholder='DD'
          variant='outlined'
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            min: 1,
            max: 31,
          }}
          sx={{ width: { xs: "80px", lg: "100px" }, mt: "0px", mr: "5px" }}
        />
        <TextField
          margin='dense'
          value={month}
          onChange={handleMonthChange}
          onBlur={handleMonthBlur}
          placeholder='MM'
          variant='outlined'
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            min: 1,
            max: 12,
          }}
          sx={{ width: { xs: "80px", lg: "100px" }, marginTop: "0px", mr: "5px" }}
        />
        <TextField
          margin='dense'
          value={year}
          onChange={handleYearChange}
          onBlur={handleYearBlur}
          placeholder='YYYY'
          variant='outlined'
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            min: 1,
          }}
          sx={{ width: { xs: "120px", lg: "140px" }, marginTop: "0px" }}
        />
      </Box>
    </>
  );
};

const validateDateOfBirth = (dateOfBirth) => {
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateOfBirth.match(dateRegex)) return false;
  const date = dayjs(dateOfBirth);
  const isValid = date.isValid() && date.date() === parseInt(dateOfBirth.split('-')[2], 10);;
  return isValid;
};

DateOfBirth.propTypes = {
  label: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setFormError: PropTypes.func.isRequired,
};

export { DateOfBirth, validateDateOfBirth };